export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "caomei-shipin-se",
    name: "草莓视频色",
    description: "掌握草莓视频色彩基础理论，从色相、明度到饱和度，理解草莓红色系的色彩特性",
    icon: "ri-palette-line",
  },
  {
    slug: "caomei-shipin-tiaose",
    name: "草莓视频调色",
    description: "专业调色流程全解析，从一级调色到二级调色，打造诱人草莓画面",
    icon: "ri-contrast-drop-2-line",
  },
  {
    slug: "caomei-paishe-jiqiao",
    name: "草莓拍摄技巧",
    description: "从灯光布置到镜头选择，全方位提升草莓视频拍摄质量的核心技法",
    icon: "ri-camera-lens-line",
  },
  {
    slug: "shipin-secai-jiaozheng",
    name: "视频色彩校正",
    description: "专业级视频色彩校正技术，确保草莓画面的色彩准确性与一致性",
    icon: "ri-color-filter-line",
  },
  {
    slug: "caomei-sewen-shezhi",
    name: "草莓色温设置",
    description: "深入理解色温对草莓画面氛围的影响，精准控制画面冷暖基调",
    icon: "ri-sun-line",
  },
  {
    slug: "shipin-shipin-tiaose",
    name: "食品视频调色",
    description: "食品类视频调色的通用法则与草莓特化技巧，让你的美食视频更诱人",
    icon: "ri-bowl-line",
  },
  {
    slug: "caomei-sheying-houqi",
    name: "草莓摄影后期",
    description: "草莓摄影后期处理全流程，从RAW文件到最终成片的完整工作流",
    icon: "ri-image-edit-line",
  },
];